export default __webpack_public_path__ + "aa21e7975d5f568571345ed3df3d5fc5.svg";